import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '@/environments/environment';
import { TrackingService } from '@/app/shared/services/tracking.service';
import { RequestPlan, planRequest, rowCountOf } from './tracking-requests';

/**
 * Ghi hành vi của nhân viên từ các lời gọi API của admin (AdminAudit pha 3): xem báo cáo, tìm khách/đơn/sản phẩm, bấm xuất dữ liệu.
 * Chỉ quan sát: không đổi request hay phản hồi, và mọi lỗi trong phần ghi đều bị bỏ qua. Khi tracking tắt thì chuyển thẳng request đi.
 * Nhật ký đầy đủ và không né được về thao tác nằm ở backend (AdminAudit); đây chỉ là phần hành vi sử dụng.
 */
@Injectable()
export class TrackingInterceptor implements HttpInterceptor {
  constructor(private tracking: TrackingService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.tracking.enabled || !req.url.startsWith(environment.baseURL)) return next.handle(req);

    let plan: RequestPlan | null = null;
    try {
      plan = planRequest(req.url, req.method, req.body, req.urlWithParams, environment.baseURL);
    } catch {
      plan = null;
    }
    if (!plan) return next.handle(req);

    if (plan.kind === 'export') {
      // Ghi lúc bấm, trước khi tải: xuất dữ liệu quan trọng ở chỗ ai bấm, không ở chỗ tải có xong không
      this.tracking.exportRequested(plan.id);
      return next.handle(req);
    }

    const started = performance.now();
    const planned = plan;
    return next.handle(req).pipe(
      tap((event) => {
        if (!(event instanceof HttpResponse) || event.status >= 300) return;
        try {
          if (planned.kind === 'search') {
            this.tracking.search(planned.target, planned.termKind, planned.termLength, rowCountOf(event.body));
          } else if (planned.kind === 'report') {
            this.tracking.reportViewed(planned.id, planned.filterNames, planned.rangeDays, performance.now() - started, rowCountOf(event.body));
          }
        } catch {
          // không ảnh hưởng thao tác của nhân viên
        }
      }),
    );
  }
}
